module.exports = __webpack_public_path__ + "img/img_level_9.7d48fa5c.png";